import { IMaterialCard } from 'constants/types/card.types'

const getCurrVideoIndex = (array: IMaterialCard[], id: number): number => {
  return array.findIndex((webinar) => webinar.id === id)
}

export { getCurrVideoIndex }
